module.exports = ".portrait {\n  height: 250px;\n  text-align: center; }\n\n.img-portrait {\n  height: 100%;\n  max-width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/character/list-character/list-character.component.scss
// module id = ./src/app/character/list-character/list-character.component.scss
// module chunks = main